<template>
  <md-card>
    <header-form
      title="EDITAR EMPRESAS"
      :rota="{ name: 'empresasRead' }"
      tooltip="Lista de Empresas"
    />

    <form @submit.prevent="update">
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-60 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.razao_social }">
              <label>RAZÃO SOCIAL</label>
              <md-input v-model="dados.razao_social" type="text"> </md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.razao_social"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.razao_social" class="validErro">
              {{ errors.razao_social[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-40 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.nome_fantasia }">
              <label>NOME FANTASIA</label>
              <md-input v-model="dados.nome_fantasia" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.nome_fantasia"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.nome_fantasia" class="validErro">
              {{ errors.nome_fantasia[0] }}
            </div>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-40 md-xsmall-size-100">
            <md-autocomplete
              :class="{ 'md-error': errors.grupo_empresa_id }"
              v-model="grupoEmpresa"
              :md-options="grupoEmpresas"
              @md-changed="autoCompleteGrupoEmpresa"
              @md-opened="autoCompleteGrupoEmpresa"
              @md-selected="getSelectedGrupoEmpresa"
            >
              <label>GRUPO DE EMPRESA</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.grupo_empresa_id"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-autocomplete>
            <div v-if="errors.grupo_empresa_id" class="validErro">
              {{ errors.grupo_empresa_id[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-15 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.tipo_pessoa_id }">
              <label for="tipo_pessoa_id">TIPO DE PESSOA</label>
              <md-select v-model="dados.tipo_pessoa_id" name="tipo_pessoa_id">
                <md-option value="1">FÍSICA</md-option>
                <md-option value="2">JURÍDICA</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.tipo_pessoa_id"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.tipo_pessoa_id" class="validErro">
              {{ errors.tipo_pessoa_id[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-25 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.cpf_cnpj }">
              <slide-y-down-transition @click.native="buscaEmpresa()">
                <md-icon class="text-site">search</md-icon>
              </slide-y-down-transition>
              <label v-if="dados.tipo_pessoa_id == 2">CNPJ</label>
              <label v-else>CPF</label>
              <md-input
                v-if="dados.tipo_pessoa_id == 2"
                v-model="dados.cpf_cnpj"
                type="text"
                v-mask="'##.###.###/####-##'"
              >
              </md-input>
              <md-input
                v-else
                v-model="dados.cpf_cnpj"
                type="text"
                v-mask="'###.###.###-##'"
              >
              </md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.cpf_cnpj">close</md-icon>
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.cpf_cnpj" class="validErro">
              {{ errors.cpf_cnpj[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>INSCRIÇÃO ESTADUAL</label>
              <md-input
                v-model="dados.inscricao_estadual"
                type="text"
              ></md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-15 md-xsmall-size-100">
            <md-field>
              <label>TELEFONE</label>
              <md-input
                v-model="dados.telefone"
                type="text"
                v-mask="['(##) ####-####', '(##) #####-####']"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15 md-xsmall-size-100">
            <md-field>
              <label>CELULAR</label>
              <md-input
                v-model="dados.celular"
                type="text"
                v-mask="['(##) ####-####', '(##) #####-####']"
              >
              </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-40 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.email }">
              <label>EMAIL</label>
              <md-input v-model="dados.email" type="text" class="lowercase">
              </md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.email">close</md-icon>
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.email" class="validErro">
              {{ errors.email[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-30 md-xsmall-size-100">
            <md-field>
              <label>CONTATO</label>
              <md-input v-model="dados.contato" type="text"> </md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>CEP</label>
              <md-input
                v-model="dados.cep"
                type="text"
                v-mask="'#####-###'"
                @keyup="buscaCep"
              >
              </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-60 md-xsmall-size-100">
            <md-field>
              <label>RUA</label>
              <md-input v-model="dados.rua" type="text"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>Nº</label>
              <md-input v-model="dados.num" type="text"> </md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-40 md-xsmall-size-100">
            <md-field>
              <label>COMPLEMENTO</label>
              <md-input v-model="dados.complemento" type="text"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-25 md-xsmall-size-100">
            <md-field>
              <label>BAIRRO</label>
              <md-input v-model="dados.bairro" type="text"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-25 md-xsmall-size-100">
            <md-field>
              <label>CIDADE</label>
              <md-input v-model="dados.cidade" type="text"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-10 md-xsmall-size-100">
            <md-field>
              <label>UF</label>
              <md-input v-model="dados.uf" type="text"> </md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-25 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.tipo_empresa_id }">
              <label for="tipo_empresa_id">TIPO DE EMPRESA</label>
              <md-select v-model="dados.tipo_empresa_id" name="tipo_empresa_id">
                <md-option value="1">CLIENTE</md-option>
                <md-option value="2">FORNECEDOR</md-option>
                <md-option value="3">CLIENTE / FORNECEDOR</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.tipo_empresa_id"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.tipo_empresa_id" class="validErro">
              {{ errors.tipo_empresa_id[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-40 md-xsmall-size-100">
            <md-autocomplete
              :class="{ 'md-error': errors.seguimento_id }"
              v-model="seguimento"
              :md-options="seguimentos"
              @md-changed="autoCompleteSeguimento"
              @md-opened="autoCompleteSeguimento"
              @md-selected="getSelectedSeguimento"
            >
              <label>SEGUIMENTO</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.seguimento_id"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-autocomplete>
            <div v-if="errors.seguimento_id" class="validErro">
              {{ errors.seguimento_id[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-autocomplete
              :class="{ 'md-error': errors.dia_fechamento_id }"
              v-model="diaFechamento"
              :md-options="diaFechamentos"
              @md-changed="autoCompleteDiaFechamento"
              @md-opened="autoCompleteDiaFechamento"
              @md-selected="getSelectedDiaFechamento"
            >
              <label>DIA FECHAMENTO</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.dia_fechamento_id"
                  >close</md-icon
                >
              </slide-y-down-transition>
            </md-autocomplete>
            <div v-if="errors.dia_fechamento_id" class="validErro">
              {{ errors.dia_fechamento_id[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-15 md-xsmall-size-100">
            <md-field>
              <label>DIA DE PGTO</label>
              <md-input v-model="dados.dia_pgto" type="text" v-mask="'##'">
              </md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.tem_limite }">
              <label for="tem_limite">CRÉDITO</label>
              <md-select v-model="dados.tem_limite" name="tem_limite">
                <md-option value="0">NÃO</md-option>
                <md-option value="1">SIM</md-option>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.tem_limite"
                    >close</md-icon
                  >
                </slide-y-down-transition>
              </md-select>
            </md-field>
            <div v-if="errors.tem_limite" class="validErro">
              {{ errors.tem_limite[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>LIMITE</label>
              <md-input v-model="dados.limite" v-money> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label for="limite_parcela">LIMITE POR PARCELA</label>
              <md-select v-model="dados.limite_parcela" name="limite_parcela">
                <md-option value="0">NÃO</md-option>
                <md-option value="1">SIM</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>QTDE PARCELA</label>
              <md-input
                v-model="dados.num_parcela_id"
                type="text"
                v-mask="'##'"
              >
              </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.retorno }">
              <label>TAXA</label>
              <md-input
                v-model="dados.retorno"
                type="text"
                v-mask="['#,##', '##,##']"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.retorno">close</md-icon>
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.retorno" class="validErro">
              {{ errors.retorno[0] }}
            </div>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-40 md-xsmall-size-100">
            <md-autocomplete
              v-model="banco"
              :md-options="bancos"
              @md-changed="autoCompleteBanco"
              @md-opened="autoCompleteBanco"
              @md-selected="getSelectedBanco"
            >
              <label>BANCO</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.banco_id">close</md-icon>
              </slide-y-down-transition>
            </md-autocomplete>
            <div v-if="errors.banco_id" class="validErro">
              {{ errors.banco_id[0] }}
            </div>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label for="tipo_conta_id">TIPO DE CONTA</label>
              <md-select v-model="dados.tipo_conta_id" name="tipo_conta_id">
                <md-option value="1">CORRENTE</md-option>
                <md-option value="2">POUPANÇA</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>AGÊNCIA</label>
              <md-input
                v-model="dados.agencia"
                type="text"
                v-mask="'###########'"
              >
              </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20 md-xsmall-size-100">
            <md-field>
              <label>CONTA</label>
              <md-input
                v-model="dados.conta"
                type="text"
                v-mask="[
                  '###-#',
                  '####-#',
                  '#####-#',
                  '######-#',
                  '#######-#',
                  '########-#',
                  '#########-#',
                  '##########-#',
                  '###########-#',
                ]"
              >
              </md-input>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-xsmall-size-100">
            <md-field :class="{ 'md-error': errors.mapa }">
              <label>MAPA</label>
              <md-input v-model="dados.mapa" type="text" class="lowercase">
              </md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.mapa">close</md-icon>
              </slide-y-down-transition>
            </md-field>
            <div v-if="errors.mapa" class="validErro">{{ errors.mapa[0] }}</div>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button type="submit" class="md-success md-round">
          <span class="md-label">
            <md-icon class="material-icons">check</md-icon> </span
          >SALVAR
        </md-button>
      </md-card-actions>
    </form>
  </md-card>
</template>

<script>
import Notify from "@/config/mixins/notify";
import BuscarEmpresa from "@/config/mixins/buscarEmpresa";
import BuscarCep from "@/config/mixins/buscarCep";
import HeaderForm from "@/pages/Layout/Extra/HeaderForm";

export default {
  components: {
    HeaderForm,
  },
  data() {
    return {
      dados: {
        tipo_pessoa_id: 2,
        limite_parcela: 0,
      },
      listBancos: [],
      listGrupoEmpresas: [],
      listDiaFechamentos: [],
      listSeguimentos: [],
      bancos: ["X"],
      banco: "",
      grupoEmpresas: ["X"],
      grupoEmpresa: "",
      diaFechamentos: ["X"],
      diaFechamento: "",
      seguimentos: ["X"],
      seguimento: "",
      errors: {},
    };
  },

  created() {
    this.getLista();
    this.getEmpresa();
  },

  mixins: [Notify, BuscarEmpresa, BuscarCep],

  methods: {
    getEmpresa() {
      this.$http
        .get(this.$urlAPI + "empresas/" + this.$route.params.id)
        .then((response) => {
          if (response.data.status) {
            this.dados = response.data.dados[0];
            this.grupoEmpresa = this.dados.grupo;
            this.banco = this.dados.banco;
            this.diaFechamento = this.dados.fechamento;
            this.seguimento = this.dados.seguimento;
          } else {
            this.danger(response.data.message);
          }
        })
        .catch((e) => {
          this.msgErrors(e);
        });
    },

    getLista() {
      this.$http
        .get(this.$urlAPI + "empresas")
        .then((response) => {
          this.listBancos = response.data.dados.banco;
          this.listGrupoEmpresas = response.data.dados.grupoEmpresa;
          this.listDiaFechamentos = response.data.dados.diaFechamento;
          this.listSeguimentos = response.data.dados.seguimento;
        })
        .catch((e) => {
          this.msgErrors(e);
        });
    },

    autoCompleteBanco(searchTerm) {
      this.bancos = new Promise((resolve) => {
        if (!searchTerm) {
          resolve(this.listBancos.map((x) => x.name));
        } else {
          const term = searchTerm.toLowerCase();
          this.bancos = this.listBancos
            .filter(({ name }) => {
              return name.toLowerCase().includes(term);
            })
            .map((x) => x.name);
          resolve(this.bancos);
        }
      });
    },

    getSelectedBanco() {
      let customer = this.banco;
      this.dados.banco_id = this.listBancos.filter(function(e) {
        return e.name === customer;
      })[0].id;
    },

    autoCompleteSeguimento(searchTerm) {
      this.seguimentos = new Promise((resolve) => {
        if (!searchTerm) {
          resolve(this.listSeguimentos.map((x) => x.name));
        } else {
          const term = searchTerm.toLowerCase();
          this.seguimentos = this.listSeguimentos
            .filter(({ name }) => {
              return name.toLowerCase().includes(term);
            })
            .map((x) => x.name);
          resolve(this.seguimentos);
        }
      });
    },

    getSelectedSeguimento() {
      let customer = this.seguimento;
      this.dados.seguimento_id = this.listSeguimentos.filter(function(e) {
        return e.name === customer;
      })[0].id;
    },

    autoCompleteGrupoEmpresa(searchTerm) {
      this.grupoEmpresas = new Promise((resolve) => {
        if (!searchTerm) {
          resolve(this.listGrupoEmpresas.map((x) => x.name));
        } else {
          const term = searchTerm.toLowerCase();
          this.grupoEmpresas = this.listGrupoEmpresas
            .filter(({ name }) => {
              return name.includes(term);
            })
            .map((x) => x.name);
          resolve(this.grupoEmpresas);
        }
      });
    },

    getSelectedGrupoEmpresa() {
      let customer = this.grupoEmpresa;
      this.dados.grupo_empresa_id = this.listGrupoEmpresas.filter(function(e) {
        return e.name === customer;
      })[0].id;
    },

    autoCompleteDiaFechamento(searchTerm) {
      this.diaFechamentos = new Promise((resolve) => {
        if (!searchTerm) {
          resolve(this.listDiaFechamentos.map((x) => x.name));
        } else {
          const term = searchTerm.toLowerCase();
          this.diaFechamentos = this.listDiaFechamentos
            .filter(({ name }) => {
              return name.toLowerCase().includes(term);
            })
            .map((x) => x.name);
          resolve(this.diaFechamentos);
        }
      });
    },

    getSelectedDiaFechamento() {
      let customer = this.diaFechamento;
      this.dados.dia_fechamento_id = this.listDiaFechamentos.filter(function(
        e
      ) {
        return e.name === customer;
      })[0].id;
    },

    update() {
      this.$http
        .put(this.$urlAPI + "empresas/" + this.dados.id, this.dados)
        .then((response) => {
          if (response.data.status) {
            this.$router.push({
              name: "empresasRead",
            });
            this.success(response.data.message);
            this.errors = "";
          } else if (response.data.errors) {
            this.errors = response.data.errors;
          } else {
            this.danger(response.data.message);
            this.errors = "";
          }
        })
        .catch((e) => {
          this.msgErrors(e);
        });
    },
  },
};
</script>
